<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.atendidosEvadidos"
            :tbody-tr-class="rowClassPaciente"
            ref="RkmTable"
            responseive
            sort-by="horarioAgendado"
        >
            <template v-slot:cell(tempoEspera)="{item}">
                <rkm-icon
                    v-if="item.tempoEspera.id"
                    :id="uniqueId('tempo-espera-tooltip')"
                    :style="'color: ' + item.tempoEspera.cor"
                    :title="formatTempoEspera(item.tempoEspera.total)"
                    font-scale="2"
                    icon="battery-full"
                    v-rkm-tooltip.hover
                />

                <span v-else>
                    -
                </span>
            </template>

            <template v-slot:cell(pacienteNome)="{index, item}">
                <template v-if="item.pacienteNome">
                    <rkm-button
                        :id="uniqueId(`paciente-icon-${index}`)"
                        class="mr-2"
                        small
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <rkm-popover
                        :target="uniqueId(`paciente-icon-${index}`)"
                        placement="top"
                        title="Dados cadastrais"
                        triggers="hover"
                    >
                        <div>
                            <span>
                                <strong>Data de nascimento:</strong> {{item.pacienteDataNascimento}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>Nome da mãe:</strong> {{item.pacienteNomeMae}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CPF:</strong> {{item.pacienteCpf}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CNS:</strong> {{item.pacienteCns}}
                            </span>
                        </div>
                    </rkm-popover>

                    <template>
                        {{item.pacienteNome}}

                        <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                            <strong>
                                ({{item.pacienteNomeSocial}})
                            </strong>
                        </template>

                        <span
                            v-if="item.pacienteObitoEm"
                            class="ml-1"
                            title="Paciente em óbito"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="cross" />
                        </span>

                        <span
                            v-if="item.pacienteBloqueado"
                            class="ml-1"
                            title="Cadastro bloqueado"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="ban" />
                        </span>

                        <span
                            v-if="isProvisorioOuTemporario(item)"
                            class="ml-1"
                            title="Paciente provisório/temporário"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="hourglass-half" />
                        </span>

                        <span
                            v-if="isNaoMunicipe(item)"
                            class="ml-1"
                            title="Paciente não munícipe"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="map-pin" />
                        </span>

                        <span
                            v-if="isSemCpfCns(item)"
                            class="ml-1"
                            title="Paciente sem CPF e CNS"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="exclamation-triangle" />
                        </span>

                        <span
                            v-if="item.pacienteResponsavelFamiliar"
                            class="ml-1"
                            title="Responsável familiar"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="crown" />
                        </span>

                        <span
                            v-if="isIdoso(item)"
                            class="ml-1"
                            title="Idoso"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="blind" />
                        </span>

                        <span
                            v-if="hasTea(item)"
                            class="ml-1"
                            title="Pessoa com Transtorno do Espectro Autista - TEA"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="infinity" />
                        </span>

                        <span
                            v-if="hasPcd(item)"
                            class="ml-1"
                            title="Pessoa com Deficiência - PCD"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="wheelchair" />
                        </span>
                    </template>

                    <span
                        v-if="item.pacienteObitoEm"
                        class="ml-1"
                        title="Paciente em óbito"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="cross" />
                    </span>

                    <span
                        v-if="item.pacienteBloqueado"
                        class="ml-1"
                        title="Cadastro bloqueado"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="ban" />
                    </span>

                    <span
                        v-if="isProvisorioOuTemporario(item)"
                        class="ml-1"
                        title="Paciente provisório/temporário"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="hourglass-half" />
                    </span>

                    <span
                        v-if="item.pacienteClassificacaoId == enums.classificacao.OUTRO_MUNICIPIO"
                        class="ml-1"
                        title="Paciente não munícipe"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="map-pin" />
                    </span>

                    <span
                        v-if="!item.pacienteCpf && !item.pacienteCns"
                        class="ml-1"
                        title="Paciente sem CPF e CNS"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="exclamation-triangle" />
                    </span>

                    <span
                        v-if="item.pacienteResponsavelFamiliar"
                        class="ml-1"
                        title="Responsável familiar"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="crown" />
                    </span>

                    <span
                        v-if="parseInt(item.pacienteIdadeAnos) >= 60"
                        class="ml-1"
                        title="Idoso"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="blind" />
                    </span>

                    <span
                        v-if="hasTea(item)"
                        class="ml-1"
                        title="Pessoa com Transtorno do Espectro Autista - TEA"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="infinity" />
                    </span>

                    <span
                        v-if="hasPcd(item)"
                        class="ml-1"
                        title="Pessoa com Deficiência - PCD"
                        v-rkm-tooltip.hover
                    >
                        <rkm-icon icon="wheelchair" />
                    </span>
                </template>
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <template v-if="!!item.evadido">
                    <rkm-button
                        :id="uniqueId(`motivo-evasao-icon-${index}`)"
                        color="info"
                        small
                    >
                        <rkm-icon icon="info" />
                    </rkm-button>

                    <rkm-popover
                        :target="uniqueId(`motivo-evasao-icon-${index}`)"
                        placement="top"
                        title="Motivo da evasão"
                        triggers="hover"
                    >
                        {{item.motivoEvasao}}
                    </rkm-popover>

                    <rkm-button
                        @click="$refs.ModalCancelamentoEvasao.open(item.filaId)"
                        color="warning"
                        small
                        title="Cancelar evasão"
                    >
                        <rkm-icon icon="undo" />
                    </rkm-button>
                </template>

                <template v-else>
                    <rkm-button
                        @click="$refs.ModalDeclaracaoComparecimento.open(item.atendimentoId, {allowsToPrint: true})"
                        color="info"
                        small
                        title="Gerar declaração de comparecimento"
                    >
                        <rkm-icon icon="file-medical" />
                    </rkm-button>
                </template>
            </template>
        </rkm-table>

        <ModalCancelamentoEvasao
            @saved="$emit('saved')"
            ref="ModalCancelamentoEvasao"
        />

        <ModalDeclaracaoComparecimento
            @saved="$emit('saved')"
            ref="ModalDeclaracaoComparecimento"
        />
    </div>
</template>

<script>
// Component.
import ModalCancelamentoEvasao from '@/components/ambulatorio/components/fila/components/evasao/components/cancelamento/Modal'
import ModalDeclaracaoComparecimento from '@/components/ambulatorio/components/declaracao-comparecimento/Modal'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import deficienciaBase from '@/enums/cadastro/cidadao/deficienciaBase'
import deficiencia from '@/enums/cadastro/cidadao/deficiencia'

export default {
    components: {
        ModalCancelamentoEvasao,
        ModalDeclaracaoComparecimento,
    },
    data: () => ({
        enums: {preferenciaNome, classificacao, subclassificacao, deficienciaBase, deficiencia},
        fields: [
            {key: 'tempoEspera', label: 'Tempo de espera'},
            {key: 'senha', label: 'Senha', sortable: true},
            {key: 'pacienteNome', label: 'Nome', sortable: true},
            {key: 'pacienteIdadeAnos', label: 'Idade', sortable: true},
            {key: 'pacienteProntuario', label: 'Prontuário', sortable: true},
            {key: 'pacienteSexoDescricao', label: 'Sexo', sortable: true},
            {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
            {key: 'usuarioNome', label: 'Profissional', sortable: true},
            {key: 'horarioChegada', label: 'Horário de chegada', sortable: true},
            {key: 'horarioAgendado', label: 'Horário agendado', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        formatTempoEspera(value) {
            let format = 'Esperando por'

            if (value.dias !== null) {
                format = `${format} ${value.dias} dia(s)`
            }

            if (value.horas !== null) {
                format = `${format} ${value.horas} hora(s)`
            }

            if (value.minutos !== null) {
                if (value.horas !== null) {
                    format = `${format} e ${value.minutos} minuto(s)`
                } else {
                    format = `${format} ${value.minutos} minuto(s)`
                }
            }

            return format
        },
        isProvisorioOuTemporario(item) {

            return item.pacienteClassificacaoId == this.enums.classificacao.PROVISORIO
                || item.pacienteSubclassificacaoId == this.enums.subclassificacao.TEMPORARIO
        },
        isNaoMunicipe(item) {

            return item.pacienteClassificacaoId == this.enums.classificacao.OUTRO_MUNICIPIO
        },
        isSemCpfCns(item) {

            return !item.pacienteCpf && !item.pacienteCns
        },
        isIdoso(item) {

            return parseInt(item.pacienteIdadeAnos) >= 60
        },
        getDeficienciasBaseIds(item) {

            return item.pacienteDeficienciasBaseIds
                ? item.pacienteDeficienciasBaseIds.split(',').map(Number)
                : []
        },
        hasTea(item) {

            return this.getDeficienciasBaseIds(item).includes(this.enums.deficienciaBase.TEA)
                || item.pacienteDeficienciaId === this.enums.deficiencia.AUTISMO
        },
        hasPcd(item) {

            return this.getDeficienciasBaseIds(item).some(id => id !== this.enums.deficienciaBase.TEA)
                || (!!item.pacienteDeficienciaId && item.pacienteDeficienciaId !== this.enums.deficiencia.AUTISMO)
        },
        rowClassPaciente(item, type) {
            if (item && type === 'row') {
                if (item.pacienteObitoEm) {
                    return 'table-purple'
                }
                if (item.pacienteBloqueado) {
                    return 'table-danger'
                }
                if (this.isProvisorioOuTemporario(item)) {
                    return 'table-orange'
                }
                if (this.isNaoMunicipe(item)) {
                    return 'table-brown'
                }
                if (this.isSemCpfCns(item)) {
                    return 'table-warning'
                }
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>